# This gets automatically populated bij gulp

exports.date = 1482499575
exports.branch = "master"
exports.hash = "3821f65"
exports.build = 2466
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee